import { navLinks } from "@/mocks/film";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                一路向西在线
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-sm">
              专注于《一路向西》的剧情相关延伸内容整理，涵盖剧情脉络、深度解说、影评观点、经典片段、幕后花絮与彩蛋细节。
              本页为内容介绍型页面，不提供影片在线播放或下载。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["剧情梳理", "主题解说", "影评观点", "彩蛋细节"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-white/10 text-background-200 font-label text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-base font-bold text-background-50">
              页面导航
            </h3>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  type="button"
                  onClick={() => scrollTo(link.id)}
                  className="text-left font-label text-sm text-background-300 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-base font-bold text-background-50">
              内容提示
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-shield-star-line text-accent-400 mt-0.5" />
                影片属三级片，仅面向成年观众
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line text-accent-400 mt-0.5" />
                影评与解说为观点性内容，仅供参考
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-movie-line text-accent-400 mt-0.5" />
                配图为主题氛围示意，非影片剧照
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-background-400">
            © {new Date().getFullYear()} 一路向西在线 · 剧情相关延伸内容整理
          </p>
          <p className="font-label text-xs text-background-400">
            本站内容基于公开资料整理，与影片版权方无隶属关系
          </p>
        </div>
      </div>
    </footer>
  );
}